import Constants from "@/services/Constants";
import AuthService from "./AuthService";

export default {
	async get() {
		let res = await AuthService.axios().get(`${Constants.adminBackend}/products/`);
		for (let x of res.data) {
			if (x.icon) x.image = x.image || "";
			if (x.image) x.icon = x.icon || "";
			x.markdown = (resolve, reject) => {
				AuthService.axios().get(
					`${Constants.adminBackend}/products/${x._id}`).then(response => {
					resolve(response.data.markdown);
				}).catch(err => {
					reject(err);
				});
			};
		}
		return res.data;
	},

	async save(item) {
		console.log("saving ", item);
		try {
			let res = await AuthService.axios().put(`${Constants.adminBackend}/products/`, item);
			return res.data;
		} catch (e) {
			console.log(e);
			alert(`保存失败\n${e}`);
			return {status: "error", message: e}
		}
	},

	async delete(id) {
		console.log("deleting ", id);
		try {
			let res = await AuthService.axios().delete(`${Constants.adminBackend}/products/${id}`);
			return res.data;
		} catch (e) {
			console.log(e);
			alert(`删除失败\n${e}`);
			return {status: "error", message: e}
		}
	}
}